export { RiskDashboard as RiskDashboardPage } from './RiskDashboard';
